module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/butcher-800.2f033c5bb1c85ecb.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/butcher-800.2f033c5bb1c85ecb.jpg",width: 800,height: 569}],
        src: "https://static.sniffspot.com/packs/img/butcher-800.2f033c5bb1c85ecb.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/butcher-800.2f033c5bb1c85ecb.jpg"},
        
        width: 800,
        height: 569
      }